import React from 'react';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from '@react-pdf/renderer';

import { ToWords } from 'to-words';
const logo = require('../Images/tgh.png');

// Styles
const styles = StyleSheet.create({
  // ... your existing styles (unchanged)
  page: {
    fontSize: 10,
    padding: 30,
    fontFamily: 'Helvetica',
    lineHeight: 1.4,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20,
    borderBottomWidth: 2,
    borderBottomColor: '#f0a027',
    paddingBottom: 10,
  },
  companySection: {
    flex: 2,
  },
  invoiceInfo: {
    flex: 1,
    alignItems: 'flex-end',
  },
  logo: {
    width: 120,
  },
  companyName: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
    marginTop: 5,
  },
  companyDetails: {
    fontSize: 9,
    color: '#666',
    marginTop: 4,
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#f0a027',
    marginVertical: 8,
  },
  table: {
    width: '100%',
    marginVertical: 5,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
    alignItems: 'center',
    minHeight: 24,
  },
  tableColHeader: {
    width: '25%',
    fontWeight: 'bold',
    backgroundColor: '#f8f8f8',
    paddingVertical: 5,
    paddingHorizontal: 4,
    color: '#333',
  },
  tableCol: {
    width: '25%',
    paddingVertical: 5,
    paddingHorizontal: 4,
    color: '#444',
  },
  amountSection: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 15,
  },
  totalAmount: {
    width: '30%',
    border: '1',
    borderColor: '#f0a027',
    padding: 8,
    backgroundColor: '#fff9f0',
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 30,
    right: 30,
    fontSize: 8,
    color: '#666',
    textAlign: 'center',
    borderTopWidth: 1,
    borderTopColor: '#eee',
    paddingTop: 8,
  },
});

const toWords = new ToWords();
const converttowords = (amount) => {
  let words = toWords.convert(amount, { currency: true, ignoreDecimal: true });
  return words;
};

const InvoicePDF = ({ invoiceData }) => {
  const rideDateObj = new Date(invoiceData?.ride_date_and_time);
  const rideDate = rideDateObj.toISOString().split('T')[0]; // YYYY-MM-DD
  const rideTime = rideDateObj.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {console.log(' this is the data i am received', invoiceData)}
        <View style={styles.header}>
          <View style={styles.companySection}>
            <Image style={styles.logo} src={logo} />
            <Text style={styles.companyName}>TGH Cabs</Text>
            <Text style={styles.companyDetails}>
              Siliguri, Darjeling(Dist), West Bengal, 734001{'\n'}
              GSTIN: 12ABCDE1234F1Z5{'\n'}
              Phone: +91 98835 87965 | Email: TGH_Operations@thegreathimalayas.com
            </Text>
          </View>

          <View style={styles.invoiceInfo}>
            <Text style={{ ...styles.sectionTitle, marginTop: 0 }}>INVOICE</Text>
            <Text style={styles.companyDetails}>
              Invoice #: {invoiceData?.booking_id || 'TGH-2024-001'}
              {'\n'}
              Date: {invoiceData?.date || '06-Feb-2025'}
              {'\n'}
              PNR: {invoiceData?.pnr || 'JEZLYP'}
            </Text>
          </View>
        </View>

        {/* Passenger Details */}
        <Text style={styles.sectionTitle}>Passenger Information</Text>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <Text style={styles.tableColHeader}>Passenger Name</Text>
            <Text style={styles.tableColHeader}>Contact Details</Text>
            <Text style={styles.tableColHeader}>Travel Details</Text>
            <Text style={styles.tableColHeader}>Seat Information</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={styles.tableCol}>
              {invoiceData?.userid?.name || 'N/A'}
            </Text>
            <Text style={styles.tableCol}>
              {invoiceData?.userid?.email || 'N/A'}
              {'\n'}
              {invoiceData?.userid?.phone_number || 'N/A'}
            </Text>
            <Text style={styles.tableCol}>
              {rideDate || '06-Feb-2025'}
              {'\n'}
              {invoiceData?.route?.name}
              {'\n'}
              Time: {rideTime}
            </Text>
            <Text style={styles.tableCol}>
              {invoiceData?.selected_seats
                ?.length > 0
                ? `${invoiceData.selected_seats
                  .join(', ')} (${invoiceData.selected_seats
                    .length} Passenger${invoiceData.selected_seats
                      .length > 1 ? 's' : ''})`
                : 'N/A'}
            </Text>
          </View>
        </View>

        {/* Vehicle & Driver Details */}
        <Text style={styles.sectionTitle}>Vehicle & Driver Details</Text>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <Text style={styles.tableColHeader}>Vehicle Number</Text>
            <Text style={styles.tableColHeader}>Vehicle Type</Text>
            <Text style={styles.tableColHeader}>Driver Name</Text>
            <Text style={styles.tableColHeader}>Driver Contact</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={styles.tableCol}>
              {invoiceData?.vehicleId?.reg_no || 'NA'}
            </Text>
            <Text style={styles.tableCol}>
              {invoiceData?.vehicleId?.brand_name || 'NA'} {invoiceData?.vehicleId?.model_name || 'NA'}
            </Text>
  
            <Text style={styles.tableCol}>
              {invoiceData?.driverId?.name || 'NA'}
            </Text>
            <Text style={styles.tableCol}>
              {invoiceData?.driverId?.phone_numbere || '+91 XXXXX XXXXX'}
            </Text>
          </View>
        </View>

        {/* Fare Details */}
        <Text style={styles.sectionTitle}>Fare Details</Text>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <Text style={styles.tableColHeader}>Description</Text>
            <Text style={styles.tableColHeader}>Amount (Rs)</Text>
            <Text style={styles.tableColHeader}>Tax</Text>
            <Text style={styles.tableColHeader}>Total (Rs)</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={styles.tableCol}>Base Fare</Text>
            <Text style={styles.tableCol}>{(invoiceData?.payment_amount * 0.82).toFixed(2)|| '0.00'}</Text>
            <Text style={styles.tableCol}>
              CGST 9.5%
              {'\n'}
              SGST 9.5%
            </Text>
            <Text style={styles.tableCol}>{(invoiceData?.payment_amount) || '0.00'}</Text>
          </View>
        </View>

        {/* Total Amount */}
        <View style={styles.amountSection}>
          <View style={styles.totalAmount}>
            <Text style={{ fontWeight: 'bold' }}>GRAND TOTAL</Text>
            <Text style={{ fontSize: 14, marginTop: 4 }}>
              Rs. {(invoiceData?.payment_amount) || '0.00'}
            </Text>
            <Text style={{ fontSize: 8, marginTop: 4 }}>{converttowords(invoiceData?.payment_amount)}</Text>
          </View>
        </View>

        {/* Payment Info */}
        <Text style={{ ...styles.sectionTitle, marginTop: 15 }}>
          Payment Information
        </Text>
        <Text style={{ fontSize: 9, lineHeight: 1.5 }}>
          Account Name: TGH Cabs{'\n'}
          Bank: State Bank of India{'\n'}
          Account No: 12345678901{'\n'}
          IFSC: SBIN0000123{'\n'}
          UPI ID: tghcabs@oksbi
        </Text>

        {/* Footer */}
        <View style={styles.footer}>
          <Text>
            Thank you for choosing TGH Cabs! {'\n'}• This is a computer generated
            invoice and does not require physical signature {'\n'} • 
            Terms & Conditions: Subject to Siliguri jurisdiction. Cancellation charges
            apply as per policy.{'\n'} • 
            Driver Details Will be shared before 24 hours of ride begins.
          </Text>
        </View>
      </Page>
    </Document>
  );
};

export default InvoicePDF;
